import React, {Component} from 'react'
import {Button, Modal, ModalBody, ModalHeader, Col, Row, Form, ModalFooter} from 'reactstrap'
import PropTypes from 'prop-types'
import {graphql, withApollo} from 'react-apollo'
import {CreateExportWps} from '../mutations'
import {GET_JOBS} from '../../JobsNotifications/graphql'
import {exportDefaultFormatKey} from '../../Profile/settings/SettingsForm'

const formats = [{name: 'Csv', value: 'csv'}, {name: 'Pdf', value: 'pdf'}]

class ExportWpsModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      format: localStorage.getItem(exportDefaultFormatKey) || 'csv',
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  static propTypes = {
    mutate: PropTypes.func.isRequired,
    onCloseFunction: PropTypes.func.isRequired,
    client: PropTypes.object.isRequired
  }

  handleSubmit(e) {
    e.preventDefault()
    this.props.mutate({
      variables: {
        type: 'WlWelds::Jobs::ExportWps',
        args: JSON.stringify({
          version: 'wps_list',
          format: this.state.format
        })
      }
    }).then(() => {
      this.props.client.query({
        query: GET_JOBS,
        fetchPolicy: 'network-only'
      }).then(({ data }) => {
        const notifyCount = data.user_jobs ? data.user_jobs.filter(job => job.notify).length : 0
        const event = new CustomEvent('changeNotifyCountInApp', { detail: { notifyCount } })
        window.dispatchEvent(event)
      })
      this.props.onCloseFunction()
    })
  }

  render() {
    return (
      <div>
        <Modal id="export-wps-modal" isOpen={true} className="modal-primary">
          <ModalHeader>Export</ModalHeader>
          <ModalBody>
            <Form>
              <Row>
                <Col md="12">
                  <h6>Choose export format:</h6>
                  <div className="raportBox">
                    {formats.map((format, i) => [
                      <input key={`ver_${i}`} type="radio" id={`format_${i}`} name="format" value={format.value}
                        onChange={(e) => this.setState({format: e.target.value})}
                        checked={this.state.format === format.value}
                      />,
                      <label key={i} htmlFor={`format_${i}`} name="version">{format.name}</label>
                    ]
                    )}
                  </div>
                </Col>
              </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button id="generate-raport-btn" className="float-right" color="primary" type="submit" onClick={this.handleSubmit}>Export</Button>
            <Button id="cancel-report-btn" className="float-right" color="danger" onClick={this.props.onCloseFunction}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

const ExportWpsWithMutation = graphql(CreateExportWps)(ExportWpsModal)

export default withApollo(ExportWpsWithMutation)



// WEBPACK FOOTER //
// ./src/components/Wps/export_wps/ExportWpsModal.js